import { UserRole } from "../../user/enums/UserRole";

export enum EmailType {
  All = "all",
  Application = "application",
  Message = "message",
  News = "news",
  Program = "program",
}

export type TEmailPreferenceRecord = Record<EmailType, boolean>;

export interface IUnsubscription {
  type: EmailType;
}

export interface IEmailPreferences {
  id: string;
  email: string;
  role: UserRole;
  unsubscriptions: IUnsubscription[];
}

export interface IEmailPreference {
  label: string;
  description: string;
  type: EmailType;
  defaultValue: boolean;
}

export type TEmailPreferencesForAllUsers = {
  [keys in
    | UserRole.School
    | UserRole.ServiceProvider
    | UserRole.Agent
    | UserRole.Parent
    | UserRole.Student
    | UserRole.Teacher]: IEmailPreference[];
};
